import { render, staticRenderFns } from "./ClassroomSales.vue?vue&type=template&id=01f34152&scoped=true"
import script from "./ClassroomSales.vue?vue&type=script&lang=js"
export * from "./ClassroomSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f34152",
  null
  
)

export default component.exports